module.exports = __webpack_public_path__ + "img/how_to_access_users.23b2f1e8.png";